import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import Swal from 'sweetalert2';
@Component({
	selector: 'app-unidades-edit',
	templateUrl: './unidades-edit.component.html',
	styleUrls: ['./unidades-edit.component.css'],
	animations: [loadingFade]
})
export class UnidadesEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public unidade_id = null;
	public clientes = [];

	public unidade_status;

	public formUnidade: FormGroup;
	constructor(private route: ActivatedRoute,
		private fb: FormBuilder,
		private authSvc: AuthService,
		private clienteSvc: ClienteService,
		private unidadeSvc: UnidadeService,
		private router: Router
	) { }

	ngOnInit() {
		this.pegaClientes();
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {
				this.unidade_id = params.id;
				// pega dados a partir do id
				this.unidadeSvc.getUnidade(params.id).then((data: any) => {
					this.unidade_status = data.unidade_status;
					this.preencheForm({
						unidade_id: data.unidade_id,
						unidade_nome: data.unidade_nome,
						cliente_id: data.cliente_id,
						unidade_status: data.unidade_status == 'S' ? true : false
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formUnidade = this.fb.group({
			unidade_id: null,
			unidade_nome: ['', [Validators.required, Validators.maxLength(100)]],
			cliente_id: [null, Validators.required],
			unidade_status: null
		});
	}

	preencheForm(dados) {
		this.formUnidade.setValue(dados);
	}

	pegaClientes() {
		this.clienteSvc.getClientes().then((data: any) => {
			this.clientes = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	enviaUnidade() {
		if (this.formUnidade.valid) {
			this.submitting = true;

			let toSend = this.formUnidade.value;
			toSend.unidade_status = toSend.unidade_status ? 'A' : 'I';
			console.log('toSend', toSend)
			if (this.unidade_id === null) { // criar
				this.unidadeSvc.criaUnidade(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Unidade cadastrada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/unidades']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.unidadeSvc.editaUnidade(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Unidade alterada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/unidades']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else {
			for (let field in this.formUnidade.controls) {
				let campo = this.formUnidade.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formUnidade.get(nome);
		return input.touched && input.invalid;
	}
}
